import {
  type WorkspaceAgentElicitationComponentType,
  type WorkspaceAgentElicitationDecision,
  type WorkspaceAgentElicitationRequestedType,
  type WorkspaceAgentElicitationRespondedCta,
} from '@air/analytics';

/** Standalone docks are the whole flow until questions can chain. */
export const WORKSPACE_AGENT_ELICITATION_STEP_INDEX = 1;

const COMPONENT_TYPE_BY_ELICITATION_TYPE: Record<
  WorkspaceAgentElicitationRequestedType,
  WorkspaceAgentElicitationComponentType
> = {
  binary_choice: 'two_options',
  describe: 'describe',
  guided_flow: 'guided_flow',
  multi_select: 'multi_select',
  search_select: 'searchable_dropdown',
  single_select: 'single_select',
  stepper: 'numeric_stepper',
  text_fields: 'text_fields',
  tool_consent: 'tool_consent',
};

export const workspaceAgentElicitationComponentType = (
  elicitationType: WorkspaceAgentElicitationRequestedType,
): WorkspaceAgentElicitationComponentType => COMPONENT_TYPE_BY_ELICITATION_TYPE[elicitationType];

/** Single and multi select always append Something else. Search lists do not. */
export const workspaceAgentElicitationHasEscapeHatch = (
  elicitationType: WorkspaceAgentElicitationRequestedType,
): boolean => elicitationType === 'single_select' || elicitationType === 'multi_select';

export const workspaceAgentElicitationDecision = ({
  cta,
  elicitationType,
}: {
  cta: WorkspaceAgentElicitationRespondedCta;
  elicitationType: WorkspaceAgentElicitationRequestedType;
}): WorkspaceAgentElicitationDecision => {
  if (elicitationType !== 'binary_choice') {
    return 'n/a';
  }

  return cta === 'approve' ? 'confirm' : 'cancel';
};

/** Option indexes, because the agent sends labels and no option ids. */
export const workspaceAgentElicitationSelectedOptionIds = (selectedIndexes: readonly number[]): string[] =>
  selectedIndexes.map(String);
